import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { MglMap, MglMarker, MglNavigationControl } from 'vue-mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';
import MapService from '../../../../../services/mapService';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreDtwinMapOverlayWizardGeoAnchorPicker',
  components: {
    MglMap: MglMap,
    MglMarker: MglMarker,
    MglNavigationControl: MglNavigationControl
  },
  props: {
    overlayInfo: {
      type: Object,
      required: false,
      default: null
    },
    addressObjectParam: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      mapAccessToken: MapService.getAccessToken(this.$store.state.app.UiTheme ? 'light' : 'dark'),
      light: 'mapbox://styles/mapbox/light-v9',
      dark: 'mapbox://styles/mapbox/dark-v10',
      dmStreets: 'mapbox://styles/digimondo/cjn4e7kzsjv8w2rlc0a574xu4',
      satellite: 'mapbox://styles/mapbox/satellite-v9',
      streets: 'mapbox://styles/mapbox/streets-v11',
      mapStyles: [{
        text: 'niotix',
        value: '1'
      }, {
        text: 'Satellite',
        value: '2'
      }, {
        text: 'Streets',
        value: '3'
      }, {
        text: 'Combo',
        value: '4'
      }],
      mapStyle: localStorage.getItem('mapStyle'),
      addressObject: {
        coordinates: []
      },
      anchor1: null,
      anchor2: null
    };
  },
  computed: {
    mapStyleSchema: function mapStyleSchema() {
      switch (this.mapStyle) {
        case '1':
          return !this.$store.state.app.UiTheme ? this.light : this.dark;

        case '2':
          return this.satellite;

        case '3':
          return this.streets;

        case '4':
          return this.dmStreets;

        default:
          return !this.$store.state.app.UiTheme ? this.light : this.dark;
      }
    }
  },
  watch: {
    overlayInfo: function overlayInfo() {
      this.drawOverlay();
    },
    addressObjectParam: function addressObjectParam() {
      var obj = cloneDeep(this.addressObjectParam);

      if (!obj.coordinates) {
        obj.coordinates = [];
      }

      this.addressObject = obj;
    },
    'addressObject.polygon': function addressObjectPolygon() {
      this.drawOverlay();
    }
  },
  mounted: function mounted() {
    var obj = cloneDeep(this.addressObjectParam);

    if (!obj.coordinates) {
      obj.coordinates = [];
    }

    this.addressObject = obj;

    if (this.addressObject.polygon) {
      this.drawOverlay();
    }
  },
  methods: {
    drawOverlay: function drawOverlay() {
      if (!this.map) {
        return;
      } // the geo-polygon (if there is one) should always be at the very top
      // so for each added layer, set its id here to put the polygon on top of it


      var currentTopLayer = 'groundLayer';

      if (!this.map.getSource('empty')) {
        // since there is no direct z-index property, create dummy layers under which stuff is positioned
        // drawOverlay should be called before any draw-controls for polygons are added,
        // as to make sure this is really at the bottom
        this.map.addSource('empty', {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: []
          }
        });
        this.map.addLayer({
          id: currentTopLayer,
          type: 'symbol',
          source: 'empty'
        });
      }

      var overlayId = 'overlay';

      if (this.map.getLayer(overlayId)) {
        this.map.removeLayer(overlayId);
      }

      if (this.map.getSource(overlayId)) {
        this.map.removeSource(overlayId);
      }

      if (this.overlayInfo) {
        this.map.addSource(overlayId, {
          type: 'image',
          url: this.overlayInfo.image,
          coordinates: this.overlayInfo.coordinates
        });
        this.map.addLayer({
          id: overlayId,
          source: overlayId,
          type: 'raster',
          paint: {
            'raster-opacity': 0.65
          }
        }, currentTopLayer);
        currentTopLayer = overlayId;
      }

      if (this.addressObject.polygon.length) {
        var overlayWizardId = 'overlayWizard';

        if (this.map.getLayer(overlayWizardId)) {
          this.map.removeLayer(overlayWizardId);
        }

        if (this.map.getSource(overlayWizardId)) {
          this.map.removeSource(overlayWizardId);
        }

        var polygonGeoJson = {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            crs: {
              type: 'name',
              properties: {
                name: 'urn:ogc:def:crs:OGC:1.3:CRS84'
              }
            },
            features: [{
              type: 'Feature',
              properties: {},
              geometry: {
                type: 'Polygon',
                coordinates: this.addressObject.polygon
              }
            }]
          }
        };
        this.map.addSource(overlayWizardId, polygonGeoJson);
        var color = MapService.markerColor('warning');
        this.map.addLayer({
          id: overlayWizardId,
          type: 'fill-extrusion',
          source: overlayWizardId,
          paint: {
            'fill-extrusion-color': color,
            'fill-extrusion-opacity': 0.5,
            'fill-extrusion-height': 2,
            'fill-extrusion-base': 0
          }
        }, currentTopLayer);
      }
    },
    onMapLoaded: function onMapLoaded(e) {
      this.map = e.map;
      this.drawOverlay();
    },
    onMapClicked: function onMapClicked(e) {
      if (!this.anchor1) {
        this.anchor1 = [e.mapboxEvent.lngLat.lng, e.mapboxEvent.lngLat.lat];
        this.$emit('update-anchor1-coordinate', {
          lon: this.anchor1[0],
          lat: this.anchor1[1]
        });
      } else if (!this.anchor2) {
        this.anchor2 = [e.mapboxEvent.lngLat.lng, e.mapboxEvent.lngLat.lat];
        this.$emit('update-anchor2-coordinate', {
          lon: this.anchor2[0],
          lat: this.anchor2[1]
        });
      }
    },
    addressSelected: function addressSelected(addressData) {
      // preserve the polygon data, as this is not returned by the address-picker
      this.addressObject = _objectSpread(_objectSpread({}, addressData), {}, {
        polygon: this.addressObject.polygon
      });

      if (this.map !== undefined) {
        this.map.flyTo({
          center: addressData.coordinates,
          pitch: 0,
          bearing: 0,
          zoom: 19.2,
          duration: 1500,
          animate: true
        });
      }
    },
    onMarker1Dragged: function onMarker1Dragged(e) {
      var latLng = e.mapboxEvent.target['_lngLat'];
      this.$emit('update-anchor1-coordinate', _objectSpread(_objectSpread({}, latLng), {}, {
        lon: latLng.lng
      }));
    },
    onMarker2Dragged: function onMarker2Dragged(e) {
      var latLng = e.mapboxEvent.target['_lngLat'];
      this.$emit('update-anchor2-coordinate', _objectSpread(_objectSpread({}, latLng), {}, {
        lon: latLng.lng
      }));
    }
  }
};